const ADMIN_BASE = '/administrator';
const ADMIN_AUTH_BASE = '/admin/auth';

const ADMIN_PATHS = {
  STORE: '/',
  BASE: ADMIN_BASE,
  DASHBOARD: `${ADMIN_BASE}/dashboard`,
  ABOUT: `${ADMIN_BASE}/about`,
  CATEGORY: `${ADMIN_BASE}/category`,
  ADMIN: {
    BASE: `${ADMIN_BASE}/admin`,
    LIST: `${ADMIN_BASE}/admin/adminList`,
    ROLES: `${ADMIN_BASE}/admin/roles`,
    SECURITY: `${ADMIN_BASE}/admin/security`,
    ACTIVITY: `${ADMIN_BASE}/admin/activity`,
    CREATE: `${ADMIN_BASE}/admin/create`,
    VIEW: `${ADMIN_BASE}/admin/view`,
  },
  SETTINGS: `${ADMIN_BASE}/settings`,
  TERMSMANAGER: `${ADMIN_BASE}/settings/terms-management`,
  PRODUCTS: {
    BASE: `${ADMIN_BASE}/products`,
    VIEWER: `${ADMIN_BASE}/products/productViewer`,
    EDITOR: `${ADMIN_BASE}/products/productEditor`,
    ADD: `${ADMIN_BASE}/products/addProduct`,
    ALIEXPRESS: `${ADMIN_BASE}/products/addProduct/aliexpress`,
    ALIEXPRESS_EDIT: `${ADMIN_BASE}/products/edit/aliexpress`,
    LIST: `${ADMIN_BASE}/products/productList`,
    EDIT: `${ADMIN_BASE}/products/editProduct/`,
    VIEW: `${ADMIN_BASE}/products/view/`,
    IMPORT: `${ADMIN_BASE}/products/import`,
    CATEGORIZED: `${ADMIN_BASE}/products/categorized`,
  },
  PARTNERAPPLICATIONMANAGEMENT: `${ADMIN_BASE}/partner-applications`,
  PARTNERSTOREMANAGEMENT: `${ADMIN_BASE}/partner-stores`,
  PARTNERPRODUCTMANAGEMENT: `${ADMIN_BASE}/partner-products`,
  PARTNERLIST: `${ADMIN_BASE}/partner-list`,
  ALIEXPRESS: `${ADMIN_BASE}/aliexpress`,
  ALIEXPRESS_INTEGRATION: `${ADMIN_BASE}/aliexpress-integration`,
  USERS: `${ADMIN_BASE}/users`,
  USER_DETAILS: `${ADMIN_BASE}/users/details`,
  WORKUPDATE: `${ADMIN_BASE}/workupdate`,
  B2C: `${ADMIN_BASE}/b2c`,
  B2C_REVIEWS: `${ADMIN_BASE}/b2c/reviews`,
  D2C: `${ADMIN_BASE}/d2c`,
  FINANCE: `${ADMIN_BASE}/finance-management`,
  PRICING: `${ADMIN_BASE}/pricing`,
  ORDERS: `${ADMIN_BASE}/orders`,
  ORDERS_PAGES: {
    ALL: `${ADMIN_BASE}/orders`,
    DETAILS: `${ADMIN_BASE}/orders/details`,
    MANUAL: `${ADMIN_BASE}/orders/manual`,
    ALIEXPRESS: `${ADMIN_BASE}/orders/aliexpress`,
    RECOVERY: `${ADMIN_BASE}/orders/recovery`,
    REFUNDS: `${ADMIN_BASE}/orders/refunds`,
    STATUS_LOGS: `${ADMIN_BASE}/orders/status-logs`,
  },
  SHIPPING: `${ADMIN_BASE}/shipping`,
  INTEGRATIONS: {
    BASE: `${ADMIN_BASE}/integrations`,
    GATEWAYS: `${ADMIN_BASE}/integrations/gateways`,
  },
  PAYMENT_GATEWAYS: `${ADMIN_BASE}/integrations/gateways`,
  PAYMENT_GATEWAYS_LEGACY: `${ADMIN_BASE}/payment-gateways`,
  COURIER_INTEGRATION: `${ADMIN_BASE}/courier-integration`,
  CAMPAIGNS: `${ADMIN_BASE}/campaigns`,
  MARKETING: `${ADMIN_BASE}/marketing`,
  ANALYTICS: `${ADMIN_BASE}/analytics`,
  COUNTRY_CURRENCY: `${ADMIN_BASE}/country-currency`,
  NOTIFICATIONS: `${ADMIN_BASE}/notifications`,
  APPLICATION: {
    BASE: `${ADMIN_BASE}/application`,
    PUSH_NOTIFICATION: `${ADMIN_BASE}/application/push-notification`,
  },
  SEO_META: `${ADMIN_BASE}/seo-meta`,
  MEDIA: `${ADMIN_BASE}/media`,
  BACKUP: `${ADMIN_BASE}/backup`,
  DISPUTES: `${ADMIN_BASE}/support`,
  MAIL_MANAGEMENT: {
    BASE: `${ADMIN_BASE}/mail-management`,
    SETTINGS: `${ADMIN_BASE}/mail-management/settings`,
    TEMPLATES: `${ADMIN_BASE}/mail-management/templates`,
    LOGS: `${ADMIN_BASE}/mail-management/logs`,
    TEST: `${ADMIN_BASE}/mail-management/test`,
  },
  MAIL_SETTINGS: `${ADMIN_BASE}/mail-management/settings`,
  VOUCHER: `${ADMIN_BASE}/voucher`,
  VOUCHER_CREATE: `${ADMIN_BASE}/voucher/create`,
  VOUCHER_EDIT: `${ADMIN_BASE}/voucher/edit`,
  AUTH: {
    BASE: ADMIN_AUTH_BASE,
    LOGIN: `${ADMIN_AUTH_BASE}/login`,
    REGISTER: `${ADMIN_AUTH_BASE}/register`,
    FORGOT_PASSWORD: `${ADMIN_AUTH_BASE}/forgot-password`,
  },
};
export default ADMIN_PATHS
